import apiClient from './client';

export interface Session {
  id: string;
  title: string;
  description?: string;
  sessionType: string;
  squadId: string;
  startTime: string;
  endTime: string;
  location?: string;
  status: string;
  notes?: string;
  maxCapacity?: number;
  cancelledAt?: string;
  cancelReason?: string;
  createdBy: string;
  createdAt: string;
  updatedAt: string;
  squad?: {
    id: string;
    name: string;
    skillLevel?: string;
    ageGroup?: string;
  };
  creator?: {
    id: string;
    firstName: string;
    lastName: string;
    email?: string;
  };
  attendances?: any[];
  _count?: {
    attendances: number;
  };
}

export interface CreateSessionData {
  title: string;
  description?: string;
  sessionType: string;
  squadId: string;
  startTime: string;
  endTime: string;
  location?: string;
  maxCapacity?: number;
}

export interface UpdateSessionData {
  title?: string;
  description?: string;
  sessionType?: string;
  startTime?: string;
  endTime?: string;
  location?: string;
  maxCapacity?: number;
  notes?: string;
}

export const sessionApi = {
  createSession: (data: CreateSessionData) => apiClient.post('/sessions', data),

  updateSession: (id: string, data: UpdateSessionData) =>
    apiClient.put(`/sessions/${id}`, data),

  cancelSession: (id: string, cancelReason: string) =>
    apiClient.post(`/sessions/${id}/cancel`, { cancelReason }),

  completeSession: (id: string, notes?: string) =>
    apiClient.post(`/sessions/${id}/complete`, { notes }),

  deleteSession: (id: string) => apiClient.delete(`/sessions/${id}`),

  getSessionById: (id: string) => apiClient.get(`/sessions/${id}`),

  getSessionsBySquad: (squadId: string, params?: {
    status?: string;
    startDate?: string;
    endDate?: string;
  }) => apiClient.get(`/sessions/squad/${squadId}`, { params }),

  getSessionsByPlayer: (playerId: string, params?: {
    status?: string;
    startDate?: string;
    endDate?: string;
  }) => apiClient.get(`/sessions/player/${playerId}`, { params }),

  getMySessions: (params?: {
    status?: string;
    startDate?: string;
    endDate?: string;
  }) => apiClient.get('/sessions/my/sessions', { params }),

  getUpcomingSessions: (params?: {
    squadId?: string;
    playerId?: string;
    limit?: number;
  }) => apiClient.get('/sessions/upcoming/all', { params }),
};
